(function () {
  const CONFIG_ID = 'desky-hover-media-config';

  function getHoverConfig() {
    if (window.__deskyHoverMediaConfig) return window.__deskyHoverMediaConfig;

    const node = document.getElementById(CONFIG_ID);
    let map = {};

    if (!node) {
      window.__deskyHoverMediaConfig = map;
      return map;
    }

    try {
      const raw = JSON.parse(node.textContent || '{}');

      if (raw && Array.isArray(raw.items)) {
        raw.items.forEach((item) => {
          if (!item || !item.handle || !item.hoverUrl) return;
          map[item.handle] = {
            url: item.hoverUrl,
            type: item.type || 'image',
          };
        });
      } else if (raw && typeof raw === 'object') {

        map = raw;
      }
    } catch (e) {
      console.warn('Hover media config JSON parse error', e);
      map = {};
    }

    window.__deskyHoverMediaConfig = map;
    return map;
  }

  function resolveCardConfig(card, hoverMap) {
    if (card.dataset.hoverUrl) {
      return {
        url: card.dataset.hoverUrl,
        type: card.dataset.hoverType || 'image',
      };
    }

    const handle = card.dataset.productHandle;
    if (!handle) return null;

    const cfg = hoverMap[handle];
    if (!cfg || !cfg.url) return null;
    return cfg;
  }

  function initCard(card, hoverMap) {
    if (card.__hoverInitDone) return;

    const cfg = resolveCardConfig(card, hoverMap);
    if (!cfg) return; 

    card.__hoverInitDone = true;

    card.classList.add('js-hover-card');
    card.dataset.hoverUrl = cfg.url;
    card.dataset.hoverType = cfg.type;

    const media = card.querySelector('.media');
    const mainImg =
      card.querySelector('.product-card__img-main') ||
      card.querySelector('img');

    if (!media || !mainImg) return;

    let hoverHost = media.querySelector('.product-card__hover-media');
    if (!hoverHost) {
      hoverHost = document.createElement('div');
      hoverHost.className = 'product-card__hover-media js-hover-media';
      hoverHost.style.position = 'absolute';
      hoverHost.style.inset = '0';
      hoverHost.style.opacity = '0';
      hoverHost.style.transition = 'opacity .2s ease';
      hoverHost.style.pointerEvents = 'none';
      media.style.position = 'relative';
      media.appendChild(hoverHost);
    }

    let loaded = false;

    function ensureLoaded() {
      if (loaded) return;
      loaded = true;

      if (cfg.type === 'video') {
        const v = document.createElement('video');
        v.src = cfg.url;
        v.autoplay = true;
        v.loop = true;
        v.muted = true;
        v.playsInline = true;
        v.preload = 'metadata';
        v.className = 'w-full h-full object-cover';
        hoverHost.appendChild(v);
      } else {
        const img = document.createElement('img');
        img.src = cfg.url;
        img.loading = 'lazy';
        img.alt = mainImg.alt || '';
        img.className = 'w-full h-full object-cover';
        hoverHost.appendChild(img);
      }
    }

    function showHover() {
      ensureLoaded();
      mainImg.style.opacity = '0';
      hoverHost.style.opacity = '1';

      if (cfg.type === 'video') {
        const v = hoverHost.querySelector('video');
        if (v) {
          v.currentTime = 0;
          v.play().catch(() => {}); 
        }
      }
    }

    function hideHover() {
      mainImg.style.opacity = '';
      hoverHost.style.opacity = '0';
    }

    card.addEventListener('mouseenter', showHover);
    card.addEventListener('mouseleave', hideHover);
  }

  function initCardsIn(root, hoverMap) {
    root.querySelectorAll('.card-wrapper').forEach((card) => {
      const wrapper = card.closest('.deskyPopular__wrapper');
  
      if (wrapper && wrapper.dataset.enableHoverMedia === 'false') {
        return;
      }
  
      initCard(card, hoverMap);
    });
  }

  function setup() {
    const hoverMap = getHoverConfig();

    initCardsIn(document, hoverMap);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches('.card-wrapper')) {
            initCard(node, hoverMap);
          } else if (node.querySelectorAll) {
            initCardsIn(node, hoverMap);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
